import { render } from "./InstgramPostreviewcom.vue?vue&type=template&id=2446eb9c&scoped=true"
import script from "./InstgramPostreviewcom.vue?vue&type=script&lang=js"
export * from "./InstgramPostreviewcom.vue?vue&type=script&lang=js"

import "./InstgramPostreviewcom.vue?vue&type=style&index=0&id=2446eb9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2446eb9c"]])

export default __exports__